// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tiny-label[data-v-19d51592]{display:inline;font-size:20px;border-radius:5px;padding:2px 5px;color:#fff}.tiny-label.red[data-v-19d51592]{background-color:#801512}.tiny-label.green[data-v-19d51592]{background-color:green}@media only screen and (max-width:601px){.tiny-label[data-v-19d51592]{font-size:16px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
